import { render, staticRenderFns } from "./DestinationNotifications.vue?vue&type=template&id=5f7aae41&"
import script from "./DestinationNotifications.vue?vue&type=script&lang=js&"
export * from "./DestinationNotifications.vue?vue&type=script&lang=js&"
import style0 from "./DestinationNotifications.vue?vue&type=style&index=0&id=5f7aae41&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports